import { render, staticRenderFns } from "./vis-timeline.vue?vue&type=template&id=0e5237a3&"
import script from "./vis-timeline.vue?vue&type=script&lang=js&"
export * from "./vis-timeline.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports